// extracted by mini-css-extract-plugin
export default {"roleDescription":"RoleManagement_roleDescription__bxm5B"};